import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { DiegoPin } from "../../../app-constants";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question:
      "Which app development services does TekRevol provide in San Diego?",
    answer: `<p>TekRevol provides full-cycle app development services including UI/UX design, discovery, game strategy, Android to iOS and iOS to Android conversion, back-end, front-end, and API integration, app testing, maintenance, launch, and post-launch updates.</p>`,
  },
  {
    question: "Are you a reputable app development firm in San Diego?",
    answer: `<p>We have a track record of creating scalable mobile applications and games for Android and iOS platforms. We have a strong portfolio, affiliations, and partnerships and above all, a sophisticated team that loves building mobile apps, games, and software programs.</p>`,
  },
  {
    question: "Do you provide app consultancy?",
    answer: `<p>Yes, TekRevol provides app consultancy which includes defining scope and timelines, game strategy, app features, prototyping competitor research, and monetization model analysis.</p>`,
  },
  {
    question: " How much does it cost to develop an app in San Diego?",
    answer: `<p>The cost of mobile app development in San Diego starts from $55,000 depending on the comprehensive scope, features, and technical requirements. You can optimize the cost of app development by changing timelines or hiring arrangements.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>

          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{DiegoPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
